var factsheetHeader = {
	label: {
		highLowBar: "Intraday-bereik",
		lastPriceDateTime: "Datum/Tijd",
		volume: "Volume",
		isin: "ISIN",
		wkn: "WKN",
		numberOfConstituents: "Aantal Bestanddelen",
		country: "Land",
		symbol: "Symbool",
		fundIssuer: "Uitgevende Instelling",
		fundCategory: "Categorie",
		pea: "PEA",
		pme: "PEA-PME",
		srd: "SRD",
		tradingStatus: "Handelsstatus",
		perf1Year: "Verschil 1 Jaar",
		perf5Years: "Verschil 5 Jaar",
		perf1Week: "Verschil 1 Week",
		perf1Month: "Verschil 1 Maand",
		suspended: "Geschorst",
		marketStatus: "Marktstatus",
		tradingPhase: "Handelsfase",
		expectedDividends: "Verwachte Dividenden",
		expectedPriceEarningsRatio: "Verwachte Koers-winstverhouding"
	},
	"true": "Ja",
	"false": "Nee",
	open: "Open",
	close: "Sluiting"
};
var nl = {
	factsheetHeader: factsheetHeader
};

export { nl as default, factsheetHeader };
